/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Voltar',
    BACK_TO_SEARCH: 'Voltar à pesquisa',
    CANCEL: 'Cancelar',
    CANCEL_DELIVERY_REQUEST: 'Cancelar pedido',
    CHANGE_DAY: 'Alterar dia',
    CHANGE_LOCATION: 'Alterar local',
    CLICK_TO_EXPAND: 'Clica ou desliza para expandir',
    COLLECT_PIN: 'PIN de recolha',
    CONFIRM: 'Confirmar',
    CURRENT_LOCATION: 'Usar localização atual',
    EDIT_PIN: 'Editar pin',
    HELP_US_IMPROVE: 'Ajuda-nos a melhorar',
    LEAVE: 'Sair',
    NEW_SEARCH: 'Nova pesquisa',
    PICK_UP_PIN: 'PIN de levantamento',
    PICK_UP_POINT: 'Ponto de recolha',
    SAME_LOCATION: 'Mesmo local',
    SCAN_QR_CODE: 'Ler o QR code',
    SEARCH: 'Procurar',
    SIGN_IN: 'Autenticar para alterar o pedido',
    SIGN_IN_FOR_EVALUATION: 'Autenticar para ajudar-nos a melhorar',
    SWIPE_DOWN: 'Deslizar para baixo para ocultar os detalhes',
    SWIPE_UP: 'Deslizar para cima para ver os detalhes'
  },
  ERRORS: {
    SERVICE_POINT_DOES_NOT_ACCEPT_COLLECTS:
      'O ponto de serviço não aceita recolhas!',
    SERVICE_POINT_DOES_NOT_ACCEPT_ICE:
      'O ponto de serviço não aceita encomendas com caixas de congelados!',
    SERVICE_POINT_DOES_NOT_HAVE_CAPACITY:
      'O ponto de serviço atingiu a capacidade máxima de encomendas.',
    SOMETHING_WENT_WRONG: 'Aconteceu um erro, tenta novamente mais tarde.',
    ZIP_CODE_WRONG_FORMAT: 'formato de código postal inválido'
  },
  LABELS: {
    CHANGE: 'Alteração',
    CLIENT_REQUEST: 'Requisitada pelo cliente',
    COMPANY_REQUEST: 'Requisitada pela Prozis',
    CURRENT: 'de',
    DELETE_MESSAGE: 'Eliminar mensagem!',
    ERROR: 'Erro',
    NEW: 'para',
    NEW_ADDRESS: 'Morada nova',
    OR: 'Ou',
    ORIGINAL_ADDRESS: 'Morada original',
    PICK_UP_POINT: 'Ponto de recolha',
    REQUIRES_CONFIRMATION: 'Alteração pendente de confirmação',
    SAME_DAY_COLLECT: 'Recolha no mesmo dia',
    SAME_DAY_DELIVERY: 'Entrega no mesmo dia',
    SCHEDULE: 'Horário',
    SEARCH_LOCATION: 'Pesquisar morada'
  },
  MESSAGES: {
    ADICIONAL_ADDRESS: 'Complemento morada',
    ADJUST_PIN: 'Ajustar pin',
    BUILDING_DOOR_NUMBER: 'N.º edifício/porta',
    CALL_US: 'dá-nos um toque',
    CHANGE_ADDRESS: 'Alterar morada',
    CHANGE_ADDRESS_AUTOMATIC_COLLECT:
      'A morada do pedido de recolha foi alterada.',
    CHANGE_ADDRESS_AUTOMATIC_DELIVERY:
      'A morada de entrega da encomenda foi alterada.',
    CHANGE_ADDRESS_TO_PICK_UP: 'Alterar morada para o ponto de recolha',
    CHANGE_COLLECT: 'Alterar recolha',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_COLLECT:
      'O dia e a morada do pedido de recolha foram alterados.',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_DELIVERY:
      'O dia e a morada de entrega da encomenda foram alteradas.',
    CHANGE_DATE_AUTOMATIC_COLLECT: 'O dia do pedido de recolha foi alterado.',
    CHANGE_DATE_AUTOMATIC_DELIVERY:
      'O dia de entrega da encomenda foi alterado.',
    CHANGE_DAY: 'Alterar dia',
    CHANGE_DELIVERY: 'Alterar entrega',
    CHAT_TITLE: 'Messages',
    CITY: 'Cidade',
    CLIENT_REQUEST_TYPE: 'Tipo de pedido',
    CONFIRM_DELETE_MESSAGE:
      'Tem a certeza de quer quer eliminar esta mensagem?',
    CURRENT_COORDINATES: 'Coordenadas atuais',
    CUSTOMER_SUPPORT: 'apoio ao cliente',
    DATE: 'Data',
    DELETE_MESSAGE_NOW_ERROR:
      'A mensagem não pode ser eliminada porque já foi lida pelo NOW.',
    DELETED_MESSAGE: 'Esta mensagem foi apagada',
    DELIVERY_HISTORY: 'Histórico',
    DETAIL: 'Detalhe',
    DOOR_NUMBER: 'N.º porta',
    FILL_SEARCH_FIELDS:
      'Preenche os campos: rua, número da porta, código postal e cidade.',
    FROM: 'De:',
    HOUR: 'hora',
    INVALID_TRACKING: 'Código de localização inválido',
    LOCATION_PREFERENCE: 'Preferência de local',
    MANDATORY_FIELD: 'Campo obrigatório.',
    MAX_CHARACTERS: 'Máximo de {max} caracteres.',
    MESSAGE: 'Mensagem',
    MESSAGES: 'Mensagens',
    NEW_MESSAGE: 'Nova mensagem',
    OBSERVATIONS: 'Observações',
    REQUEST_APROVED: 'Pedido aceite',
    REQUEST_CANCEL_TITLE: 'Cancelar pedido',
    REQUEST_CHANGE_ADDRESS: 'Pedido de alteração de morada',
    REQUEST_CHANGE_DATE: 'Pedido de alteração de data',
    REQUEST_CHANGE_DATE_AND_ADDRESS: 'Pedido de alteração de data e morada',
    REQUEST_CONTACT: 'Pedido de contacto',
    REQUEST_CONTACT_TITLE: 'Solicitar contacto',
    REQUEST_MESSAGE: 'Pedido de mensagem',
    REQUEST_REJECTED: 'Pedido rejeitado',
    SEARCH_ADDRESS: 'Procurar morada',
    SEND_MESSAGE: 'Nova mensagem',
    STATUS: 'Estado',
    STATUS_CANCELED: 'Cancelado',
    STATUS_PENDING_TREATMENT: 'Pendente',
    STATUS_REJECTED: 'Rejeitado',
    STATUS_TREATED: 'Aprovado',
    STREET: 'Rua',
    TO: 'Para:',
    TYPE_MESSAGE: 'Escreve a tua mensagem...',
    ZIP_CODE: 'Código postal'
  },
  SENTENCES: {
    ADDRESS_NOT_FOUND:
      'Não foi possível encontrar o endereço 😞, tente novamente.',
    CONFIRM_CHANGE:
      'O teu pedido foi submetido com sucesso. Vamos analisar a melhor forma de te ajudar 🙂.',
    CONFIRM_CHANGE_AUTOMATIC: 'O teu pedido foi aceite com sucesso 🙂.',
    CONFIRM_ERROR: 'Ocorreu um erro. Volta a tentar mais tarde.',
    COORDINATES_NOT_FOUND:
      'Não foram encontradas coordenadas para a morada escolhida.',
    DELIVERY_REQUEST_FAIL: 'Erro ao cancelar pedido!',
    INVALID_DESTINATION: 'Endereço de destino inválido!',
    MAXIMUM_CONTACT_REQUESTS:
      'Podes fazer no máximo {total} pedido(s) de contacto.',
    MAXIMUM_REACHED: 'O número máximo de pedidos foi atingido!',
    MAXIMUM_REQUESTS: 'Podes fazer no máximo {total} pedido(s) de alteração.',
    MAXIMUM_REQUESTS_LEFT: 'Faltam {left}.',
    NOT_FOUND: 'Não foi possível encontrar o que estás à procura.',
    NUMBER_OF_PACKAGES: '(composta por {total} caixas)',
    OUT_OF_RANGE:
      'A morada para a qual estás a tentar alterar está fora do alcance do NOW. Para proceder a esta alteração, entra em contacto com o nosso {support}.',
    PICK_UP_NOT_FOUND:
      'Não foi possível encontrar um ponto de recolha 😞, tenta novamente.',
    REQUEST_CANCEL_DESCRIPTION:
      'Tens a certeza de que queres cancelar o pedido de alteração?',
    REQUEST_CHANGE_APPROVED: 'O teu {type} foi aceite.',
    REQUEST_CHANGE_REJECTED: 'Não foi possível aceitar o teu {type}.',
    REQUEST_CONTACT_APPROVED: 'Vamos responder ao teu {type}.',
    REQUEST_CONTACT_DESCRIPTION:
      'Após confirmação, entraremos em contacto assim que possível 🙂.',
    REQUEST_CONTACT_EVALUATION:
      'Existe um pedido de contacto efetuado. Iremos entrar em contacto em breve. Obrigado.',
    REQUEST_CONTACT_REJECTED: 'Não vai ser possível responder ao teu {type}.',
    REQUEST_CONTACT_SUBMITTED:
      'O teu pedido foi submetido com sucesso. Serás contactado por alguém do PROZIS NOW assim que possível 🙂.',
    SHOW_COLLECT_QR_CODE:
      'Mostra este código no ponto de recolha para poderes entregar o que é para ser recolhido.',
    SHOW_DELIVERY_QR_CODE:
      'Mostra este código no ponto de recolha para poderes levantar a tua encomenda.',
    STATUS_COLLECT_FAKE_PROCESSING:
      'o teu pedido de recolha será processado até {date}. Obrigado 😉.',
    STATUS_COLLECT_IN_INTERRUPTED_ROUTE:
      'a rota está atualmente interrompida devido a problemas técnicos, o teu pedido será retomado assim que possível.',
    STATUS_COLLECT_IN_ROUTING:
      'já estamos a caminho e o teu pedido de recolha vai acontecer entre as {from} e as {to} por {driver}. Está quase 😉.',
    STATUS_COLLECT_IN_SERVICE_POINT:
      'estamos a aguardar que coloques o que é pretendido recolher no {name}.',
    STATUS_COLLECT_ON_THE_WAY_TO_SERVICE_POINT:
      'já estamos a caminho e o teu pedido de recolha vai acontecer entre as {from} e as {to} por {driver} no ponto de recolha {name}. Está quase 😉.',
    STATUS_COLLECT_PROCESSING:
      'o teu pedido de recolha já foi processado no dia {date} às {hour}. Já falta pouco 😉.',
    STATUS_COLLECT_SUCCESS:
      'o teu pedido já foi recolhido por {driver} no dia {date} às {hour}. Se alguma coisa não estiver bem, {support}.',
    STATUS_COLLECT_UNSUCCESS: '{driver} não conseguiu recolher o teu pedido.',
    STATUS_COLLECTED_SERVICE_POINT:
      'o teu pedido foi recolhido no {pickUp} no dia {date} às {hour}.',
    STATUS_DELIVERED_SERVICE_POINT:
      'a tua encomenda {packages} foi levantada no ponto de recolha {pickUp} no dia {date} às {hour}.',
    STATUS_DELIVERY_FAKE_PROCESSING:
      'a tua encomenda será processada até {date}. Obrigado 😉.',
    STATUS_DELIVERY_IN_INTERRUPTED_ROUTE:
      'a rota está atualmente interrompida devido a problemas técnicos, o teu pedido será retomado assim que possível.',
    STATUS_DELIVERY_IN_ROUTING:
      'a tua encomenda {packages} já está a caminho e vai ser entregue entre as {from} e as {to} por {driver}. Está quase a chegar 😉.',
    STATUS_DELIVERY_IN_SERVICE_POINT:
      'a tua encomenda {packages} encontra-se disponível para levantamento no ponto de recolha {name}.',
    STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL:
      'Tens até ao dia {date} para levantares a tua encomenda {packages}.',
    STATUS_DELIVERY_ON_THE_WAY_TO_SERVICE_POINT:
      'a tua encomenda {packages} já está a caminho e vai ser entregue entre as {from} e as {to} por {driver} no ponto de recolha {name}. Está quase a chegar 😉.',
    STATUS_DELIVERY_PROCESSING:
      'a tua encomenda {packages} já foi processada no dia {date} às {hour} e está no centro de distribuição {location}. Já falta pouco 😉.',
    STATUS_DELIVERY_SUCCESS:
      'a tua encomenda {packages} já foi entregue por {driver} no dia {date} às {hour}. Se alguma coisa não estiver bem, {support}.',
    STATUS_DELIVERY_UNSUCCESS: '{driver} não conseguiu entregar a encomenda.',
    STATUS_HELLO: '👋 Olá, {name},',
    UPDATING_CHANGE: 'Estamos a atualizar o teu pedido 🙂',
    WARNING_DELIVERY_DELAY:
      'Aviso: Estamos com atraso nas nossas entregas. Para informação adicional, contacta {support}.',
    WARNING_REDUCED_EXPIRATION_DATE:
      'Atenção: a encomenda contém um ou mais artigos com validade reduzida que expiram em {date}. Pretendes continuar?'
  }
};
